var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.938,
    height: 13.938,
    viewBox: "0 0 13.938 13.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.969,0a6.969,6.969,0,1,0,6.969,6.969A6.977,6.977,0,0,0,6.969,0Zm-.29,11.615a.871.871,0,1,1,.871-.871A.872.872,0,0,1,6.679,11.615ZM7.55,8.073V9a.29.29,0,0,1-.29.29H6.1A.29.29,0,0,1,5.807,9V7.55A1.163,1.163,0,0,1,6.969,6.388,1.162,1.162,0,1,0,5.807,5.227v.29a.29.29,0,0,1-.29.29H4.356a.29.29,0,0,1-.29-.29v-.29A2.9,2.9,0,1,1,7.55,8.073Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.1dce054255c8b7f7ff0c5c365715c6e1.svg";
export { ForwardRef as ReactComponent };